import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { Link } from "react-router-dom"

import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { resetInvitationState } from "@/redux/slices/invite/invitationSlice"
import noInviteImage from "@/assets/images/noInviteImage.svg" // Adjust the path as necessary <img
import { useAppDispatch, useAppSelector } from "../../redux/store"

import { IoAddCircleSharp } from "react-icons/io5"

const NoInviteHome = () => {
  const [isLoadingImage, setIsLoadingImage] = useState(true)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleImageLoad = () => {
    setIsLoadingImage(false)
  }
  const navigate = useNavigate()

  const handleRedirect = () => {
    // Navigate to the first URL
    navigate("/", { replace: true })
    // Then navigate to the second URL
    setTimeout(() => {
      navigate("/subscription")
    }, 50) // Ensure it happens immediately after
  }
  return (
    <div className="container mt-1 mb-2 ">
      <div
        className=" d-flex flex-column flex-md-row row  align-items-center justify-content-center  ms-1 me-1 ms-md-2 me-md-2 mb-2 "
        style={{ minHeight: "60vh", margin: "0 0rem" }} // Ensure full height and margin
      >
        <img
          src={noInviteImage}
          // width="100%"
          // height="400px"
          style={{
            height: "300px",
            width: "300px",
            objectFit: "contain",
          }}
        />
        <h6 className="mt-4 fw-bold d-flex align-items-center justify-content-center">
          {t("invitation.noInvitations")}
        </h6>
      </div>
    </div>
  )
}
export default NoInviteHome
